import { defineComponent as r, createBlock as o, openBlock as h, unref as p, mergeProps as i, withCtx as m, createElementVNode as a } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const v = /* @__PURE__ */ r({
  name: "IconChargingWire",
  __name: "IconChargingWire",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (l, e) => (h(), o(p(c), i(n, { "view-box": "0 0 24 24" }), {
      default: m(() => e[0] || (e[0] = [
        a("path", { d: "M15.25 9.75h-8.5v5.75a1.75 1.75 0 0 0 1.75 1.75h5a1.75 1.75 0 0 0 1.75-1.75V9.75m1.5 5.75a3.25 3.25 0 0 1-3.25 3.25h-5a3.25 3.25 0 0 1-3.25-3.25v-6A1.25 1.25 0 0 1 6.5 8.25h9a1.25 1.25 0 0 1 1.25 1.25v6" }, null, -1),
        a("path", { d: "M15.75 9h-1.5V3.75h-6.5V9h-1.5V3.5A1.25 1.25 0 0 1 7.5 2.25h7a1.25 1.25 0 0 1 1.25 1.25V9m2.239 8.232 2.018-3.172c.183-.287.627-.097.545.233L20 16.5h1.63a.5.5 0 0 1 .431.752l-2.092 3.586c-.172.296-.626.118-.552-.216L20 18h-1.59a.5.5 0 0 1-.421-.768M10.25 21v-3a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-1.5 0" }, null, -1)
      ])),
      _: 1,
      __: [0]
    }, 16));
  }
});
export {
  v as default
};
